'use client';

import IconButton from '@enlighten/design-system/dist/IconButton';
import Image from 'next/image';

import IconClipboard from '@/assets/images/sns/link.png';
import type { WordpressLang } from '@/components/wordpress/utils/constants';
import { useOnChangeMessage } from '@/contexts/layouts/MessageProvider';

const TEXT: Record<WordpressLang, string> = {
	ko: 'URL 주소가 복사되었습니다.',
	en: 'The URL has been copied.',
};

interface ClipboardButtonProps {
	text: string;
	lang: WordpressLang;
}

const ClipboardButton = ({ text, lang }: ClipboardButtonProps) => {
	const onChangeMessage = useOnChangeMessage();

	return (
		<IconButton
			onClick={() => {
				navigator.clipboard.writeText(text);
				onChangeMessage({
					type: 'success',
					message: TEXT[lang],
					duration: 5000,
				});
			}}
		>
			<Image src={IconClipboard} alt="clipboard icon" width={40} />
		</IconButton>
	);
};

export default ClipboardButton;
